// extracted by mini-css-extract-plugin
export default {"abstract":"Abstract__abstract___V8wNr","noAbstract":"Abstract__noAbstract___b7A9r"};